export function format(str, data) {
	if (!data || !str) return str //do not format if empty
	if(str.indexOf("{") < 0) return str //do not format if no placeholder found

	return str.replace(/\{([a-zA-Z0-9]{1,15})\}/g, (match, g1) => {
		let val = data[g1]
		if(val != undefined) {
			return val
		} else {
			return ""
		}
	})
}